<template>
  <div
    class="template-menu"
    @scroll="handleScroll"
  >
    <div class="template-menu-top">
      <MenuHeader title="绿幕数字人" />
      <TagMenu
        v-if="false"
        v-model="currentOp"
        :tag-list="tagList"
      />
      <a-input-group class="filter-box">
        <FilterBox
          v-if="false && currentOp !== 'mine'"
          :panel-list="panelList"
          class="ant-input-group-addon"
          @confirm="handleOptionConfirm"
        />
        <a-input-search
          class="template-menu-input"
          placeholder="请输入搜索关键字"
          @search="onSearch"
        />
      </a-input-group>
    </div>
    <div class="template-menu-spacer" />
    <a-spin
      :spinning="loading"
      class="video-template-list"
    >
      <div v-if="!figureList.length" style="margin-bottom: 50px;">
        <span>
          请现在<a
            :href="resourcesURL+'&type=greenScreenDigitalHuman'"
            target="_blank"
          >我的资源</a>中添加绿幕数字人
        </span>
      </div>
      <span v-if="!figureList.length" />
      <a-empty
        v-if="!figureList.length && !loading"
        :style="{
          margin: '32px 30px 0 0',
          flexGrow: 1,
          opacity: loading ? 0 : 1,
          transition: '.3s'
        }"
        :image="defaultImage"
      />
      <div
        v-for="item in figureList"
        :key="item.id"
        class="video-template-item"
        @click="templateClick(item)"
      >
        <img
          v-if="item.attribute_name == '标准'"
          title="标准"
          class="meal-icon"
          src="/preview/icon/user_meal1.png"
          alt="标准"
        >
        <img
          v-else-if="item.attribute_name == '专业'"
          class="meal-icon"
          title="专业"
          src="/preview/icon/user_meal2.png"
          alt="专业"
        >
        <img
          v-else-if="item.attribute_name == '旗舰'"
          class="meal-icon"
          title="旗舰"
          src="/preview/icon/user_meal3.png"
          alt="旗舰"
        >
        <img
          v-if="item.cover_url"
          :src="item.cover_url"
          alt="Fragment Preview"
          class="video-clip-custom-img"
        >
        <img
          v-else
          class="video-clip-custom-img"
          src="https://img001.aivideo8.com/ai_video/U71-2020-05-08-img-1588927160629.png?x-oss-process=image/resize,w_216"
        >
        <img
          v-if="item.file_url"
          src="/preview/icon/video-preview.png"
          alt="Preview"
          class="preview-icon"
          @click.stop="handlePreview(item)"
        >
        <span
          v-if="false && currentOp !== 'mine'"
          class="tem_used_icon"
          :class="{ block: item.is_collect }"
          :title="item.is_collect ? '取消收藏' : '收藏'"
          :style="{
            'background-image': item.is_collect
              ? 'url(/preview/icon/icon_collected.png)'
              : 'url(/preview/icon/icon_collect.png)'
          }"
          @click.stop="starClick(item)"
        />
        <div
          :title="item.name"
          class="video-clip-custom-title"
        >
          {{ item.name }}
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import MenuHeader from '../base/MenuHeader'
import TagMenu from '../base/TagMenu'
import FilterBox from '../base/FilterBox'
import { Empty } from 'ant-design-vue'
import { post } from '../../utils/api'
// import { useStore } from './vueHookAPI'
// const store = useStore()
export default {
  name: 'MusicMenu',
  components: {
    MenuHeader,
    TagMenu,
    FilterBox
  },
  data: function () {
    return {
      tagList: [{ tag: '推荐模板', op: 'public' }, { tag: '我的模板', op: 'mine' }],
      currentOp: 'public',
      loading: true,
      page: 1,
      order: 'id',
      keyword: '',
      scene: '',
      industry: '',
      style: '',
      media: '',
      defaultImage: Empty.PRESENTED_IMAGE_SIMPLE,
      figureList: []
    }
  },
  computed: {
    ...mapState(['videoTemplateList', 'templateSceneList', 'templateIndustryList', 'templateStyleList', 'templateMediaList', 'isFisher']),
    // tagList() {
    //   if (this.isFisher) {
    //     return [{ tag: '推荐模板', op: 'public' }]
    //   }
    //   return [{ tag: '推荐模板', op: 'public' }, { tag: '我的模板', op: 'mine' }]
    // },
    figureEffect () {
      return this.$store.getters.figureEffect
    },
    resourcesURL () {
      return this.$store.state.fisherInfo.resourcesURL
    },
    searchMarker () {
      return [
        this.keyword,
        this.$store.state.screenRatio,
        this.currentOp,
        this.scene,
        this.industry,
        this.style,
        this.media
      ].join(',')
    },
    panelList () {
      return [{
        title: '全部场景',
        radio: this.scene,
        prop: 'scene',
        list: this.templateSceneList
        // }, {
        //   title: '全部行业',
        //   radio: this.industry,
        //   prop: 'industry',
        //   list: this.templateIndustryList
      }, {
        title: '全部风格',
        radio: this.style,
        prop: 'style',
        list: this.templateStyleList
        // }, {
        //   title: '全部平台',
        //   radio: this.media,
        //   prop: 'media',
        //   list: this.templateMediaList
      }]
    }
  },
  watch: {
    searchMarker () {
      // this.processGetTemplateList()
      this.getFigureList()
    }
  },
  beforeDestroy () { },
  mounted () {
    this.getFigureList()
    console.log('store', this.$store)
    console.log('figureEffect', this.$store.getters.figureEffect)
    // this.getTemplateSceneIndustryList();
    // this.processGetTemplateList()
  },
  methods: {
    ...mapActions(['getVideoTemplateList', 'applyVideoTemplate', 'delCollect', 'addCollect']),
    ...mapMutations([]),
    onSearch: function (search) {
      this.keyword = search
    },
    handleOptionConfirm (e) {
      Object.keys(e).forEach(k => {
        this[k] = e[k]
      })
    },
    handlePreview (item) {
      this.$store.commit('handleCurrentPresetTemplate', item)
    },
    async processGetTemplateList (next) {
      if (!next) {
        this.page = 1
        this.lastPage = false
      }

      if (!this.lastPage) {
        this.loading = true

        const ret = await this.getVideoTemplateList({
          keyword: this.keyword,
          tab: this.currentOp,
          page: this.page,
          scene: this.currentOp === 'public' ? this.scene : '',
          industry: this.currentOp === 'public' ? this.industry : '',
          style: this.currentOp === 'public' ? this.style : '',
          media: this.currentOp === 'public' ? this.media : ''
        })
        console.log('ret', ret)
        console.log('videoTemplateList', this.videoTemplateList)
        if (ret) {
          this.lastPage = ret.last
          this.page++
          this.loading = false

          setTimeout(this.handleScroll, 300)
        }
      }
    },
    handleScroll () {
      // const menu = this.$el
      // if (this.loading) {
      //   return
      // }
      // if (menu.scrollTop + menu.clientHeight >= menu.scrollHeight - 30) {
      //   this.processGetTemplateList(true)
      // }
    },
    templateClick (item) {
      this.$store.state.currentFigure = item
      this.$store.state.currentFigureId = item.id
      this.$store.state.currentFigureSrc = item.url
      if (this.figureEffect) {
        this.figureEffect.content.src = item.url
        this.figureEffect.figureId = item.id
        this.figureEffect.figureName = item.name
        this.figureEffect.content.name = item.name
      }
    },
    // 点击收藏
    async starClick (item) {
      if (item.is_collect) {
        // 取消
        await this.delCollect({ type: 'template', id: item.id })
        this.$set(item, 'is_collect', false)
      } else {
        // 收藏
        await this.addCollect({ type: 'template', id: item.id })
        this.$set(item, 'is_collect', true)
      }
    },
    async getFigureList () {
      this.loading = true
      const params = {
        file_type: 3, status: 2
      }
      if (this.keyword) {
        params.name = this.keyword
      }
      const list = await post(
        'digital-people/material/list',
        params,
        false,
        res => {
          console.log(res)
        })
      console.log('getFigureList', list)
      this.figureList = list.map(i => {
        return {
          ...i,
          qurl: i.file_url,
          url: i.cover_url
        }
      })
      // this.figureList = []
      console.log('loading', this.$store.state.loading)
      console.log('currentFigure', this.$store.state.currentFigure)
      const select = () => {
        console.log('loading', this.$store.state.loading)
        console.log('currentFigure', this.$store.state.currentFigure)
        if (this.$store.state.loading) {
          setTimeout(() => {
            select()
          }, 300)
        } else {
          if (this.$store.state.currentFigure === null && this.figureList.length > 0) {
            this.templateClick(this.figureList[0])
          }
        }
      }
      if (this.$store.state.currentFigure === null) {
        select()
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
.template-menu {
  background: rgba(247, 248, 249, 1);
  box-shadow: -1px 0 0 0 rgba(220, 220, 222, 1);
  padding: 0 16px;
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
}
.template-menu-top {
  padding: 10px 0 6px;
  position: absolute;
  z-index: 2;
  background: #f7f8f9;
  width: 232px;
  box-sizing: border-box;
}

.filter-box {
  display: flex;
  align-items: center;
  margin-top: 13px;
}

.template-menu-spacer {
  height: 100px;
  transition: 100ms;
}

.video-template-list {
  overflow: hidden;
}

.video-template-item {
  margin: 0 14px 20px 0;
  width: 108px;
  position: relative;
}

.video-template-item:hover .tem_used_icon,
.tem_used_icon.block {
  display: block;
}

.video-clip-custom-img {
  object-fit: contain;
  width: 100%;
  height: 60px;
  background: #cccccc;
}

.preview-icon {
  position: absolute;
  right: 2px;
  bottom: 24px;
}

.tem_used_icon {
  display: none;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center 0;
  cursor: pointer;
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
}

.meal-icon {
  width: 20px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.video-clip-custom-title {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  /* color: rgba(0, 0, 0, 0.65); */
  margin: 4px 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style>
.template-menu > .ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
  position: fixed;
  top: 400px;
  left: 200px;
}

.video-template-list .ant-spin-container {
  display: flex;
  flex-wrap: wrap;
  margin-right: -14px;
  align-items: flex-start;
  align-content: start;
}
</style>
